import React, { useState } from "react";
import moment from "moment";

const EventDetailsLeftArea = ({ evt }) => {
  const [activeTab, setActiveTab] = useState("details");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const apiBase = process.env.REACT_APP_BASE_URL || "";
  const att = evt?.attributes || {};
  const imgUrl = att.detailsImage?.data?.attributes?.url;
  const fullImgSrc = imgUrl ? `${apiBase}${imgUrl}` : null;

  return (
    <div className="hn-detail-main-left">
      <div className="hn-detail-image-wrap" onClick={() => fullImgSrc && setLightboxOpen(true)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && setLightboxOpen(true)}>
        <img
          src={fullImgSrc || "https://via.placeholder.com/800x420?text=Event"}
          alt={att.title}
        />
      </div>
      <ul className="hn-detail-stats">
        <li><i className="bi bi-calendar2-week" /> {moment(att.startDate).format("DD MMM, YYYY")}</li>
        <li><i className="bi bi-tag" /> {att.ticketPrice === 0 ? "Free" : `N$ ${att.ticketPrice}`}</li>
        <li><i className="bi bi-pin-map" /> {att.address?.city?.data?.attributes?.name}, {att.address?.street}</li>
      </ul>
      <div className="hn-detail-info-grid">
        {att.contact && (
          <div className="hn-detail-info-card">
            <h5>Contact</h5>
            <p>{att.contact?.name}, {att.contact?.number}</p>
          </div>
        )}
        {att.link && (
          <div className="hn-detail-info-card">
            <h5>Link</h5>
            <a target="_blank" rel="noreferrer" href={att.link}>{att.link}</a>
          </div>
        )}
        {att.mapsLink && (
          <div className="hn-detail-info-card">
            <h5>Map</h5>
            <a target="_blank" rel="noreferrer" href={att.mapsLink}>Open in Maps</a>
          </div>
        )}
      </div>
      <div className="hn-detail-tabs">
        <button type="button" className={activeTab === "details" ? "active" : ""} onClick={() => setActiveTab("details")}>
          <i className="bi bi-info-circle" /> Details
        </button>
        <button type="button" className={activeTab === "schedule" ? "active" : ""} onClick={() => setActiveTab("schedule")}>
          <i className="bi bi-calendar3" /> Schedule
        </button>
      </div>
      <div className="hn-detail-content">
        {activeTab === "details" && (
          <>
            <h3 style={{ marginTop: 0 }}>{att.title}</h3>
            <p style={{ whiteSpace: "pre-line" }}>{att.description}</p>
          </>
        )}
        {activeTab === "schedule" && (
          <p>
            <strong>{moment(att.startDate).format("DD MMM")} – {moment(att.endDate).format("DD MMM, YYYY")}</strong>
            <br />
            See you there.
          </p>
        )}
      </div>

      {lightboxOpen && fullImgSrc && (
        <div
          className="hn-modal-backdrop"
          onClick={() => setLightboxOpen(false)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Escape" && setLightboxOpen(false)}
          aria-label="Close"
        >
          <button type="button" className="hn-modal-close" onClick={() => setLightboxOpen(false)} aria-label="Close">
            <i className="bi bi-x-lg" />
          </button>
          <img src={fullImgSrc} alt={att.title} className="hn-modal-content" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
};

export default EventDetailsLeftArea;
